import { reportErrorToNewRelic } from "../helpers/newRelic";
import httpService from "./HttpService";

const SIDES = ["frente", "dorso"];

// URL firmada de 60 s de la imagen de un documento ya cargado:
// GET {REACT_APP_DOC_PREVIEW_EP}/{idPax}/{side}. El listado de pax ya no trae
// URLs: sólo has_document_front / has_document_back. null ante cualquier error.
export const getDocPreviewUrl = (paxId, side) => {
  const base = (process.env.REACT_APP_DOC_PREVIEW_EP || "").replace(/\/+$/, "");
  if (!base || !paxId || SIDES.indexOf(side) === -1)
    return Promise.resolve(null);
  return httpService
    .get(
      `${process.env.REACT_APP_API2_EP}${base}/${encodeURIComponent(
        paxId
      )}/${side}`,
      { skipErrorToast: true }
    )
    .then(res => {
      const url = res && res.data && res.data.url;
      return typeof url === "string" && url ? url : null;
    })
    .catch(err => {
      reportErrorToNewRelic("DOC_PREVIEW_EP", err);
      return null;
    });
};
